import React, {memo} from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'

import {ReactComponent as PaletteIcon} from '../assets/images/icons/palette-extra.svg'
import {ReactComponent as CommercialIcon} from '../assets/images/icons/commercial-extra.svg'
import {ReactComponent as RocketIcon} from '../assets/images/icons/rocket-extra.svg'
import ScrollAnimation from './ScrollAnimation'
import './Extras.scss'

const extras = [
  {
    id: 1,
    title: 'brand refresh',
    Icon: PaletteIcon,
    period: '1 week',
    text:
      'Our team of professional designers can update your logo, font and colour pallete to make it easily recognizable and memorable.',
  },
  {
    id: 2,
    title: 'digital marketing',
    Icon: CommercialIcon,
    period: 'monthly',
    isPriceFrom: true,
    text:
      'We monitor what your target market is so we can devise a strategy on how to gain new customers and keep your existing customers satisfied.',
  },
  {
    id: 3,
    title: 'support',
    Icon: RocketIcon,
    period: 'monthly',
    isPriceFrom: true,
    text:
      'We don’t just design and build, we also offer technical support for your website to prevent or fix bugs in real time. ',
  },
]

const StyledGrid = withStyles({
  root: {
    '&:not(:last-child)': {
      marginBottom: 24,
    },
  },
})(Grid)

const renderedExtras = extras.map(extra => (
  <ScrollAnimation key={extra.id} tag="li" className="Extras-Item" effect="fadeInBottom">
    <StyledGrid container spacing={2}>
      <Grid item xs={12} sm={8}>
        <div className="Extras-ItemBlock">
          <div className="Extras-ItemIconBlock">
            <extra.Icon className="Extras-ItemIcon" />
          </div>
          <div>
            <h3 className="Extras-ItemTitle">{extra.title}</h3>
            <Hidden xsDown>
              <p className="Extras-ItemText">{extra.text}</p>
            </Hidden>
          </div>
        </div>
      </Grid>
      <Hidden smUp>
        <Grid item xs={12}>
          <p className="Extras-ItemText">{extra.text}</p>
        </Grid>
      </Hidden>
      <Grid item xs={12} sm={4}>
        <div className="Extras-ItemPriceBlock">
          <p className="Extras-ItemPeriod">{extra.period}</p>
          <p className="Extras-ItemPrice">
            {extra.isPriceFrom && <span className="Extras-ItemTip">from</span>}
            <span className="Extras-ItemCurrency">$</span>500 nzd
          </p>
        </div>
      </Grid>
    </StyledGrid>
  </ScrollAnimation>
))

function Extras() {
  return (
    <section className="Extras Container">
      <Grid container spacing={2}>
        <Hidden xsDown>
          <Grid item sm={1} lg={2} />
        </Hidden>
        <Grid item xs={12} sm={10} lg={8}>
          <h2 className="Extras-Title Title">Extras</h2>
          <ul>{renderedExtras}</ul>
        </Grid>
        <Hidden xsDown>
          <Grid item sm={1} lg={2} />
        </Hidden>
      </Grid>
    </section>
  )
}

export default memo(Extras)
